import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DataCollection from '../../shared/DataCollection';
import DeleteButton from '../../shared/DeleteButton.js';
import '../FinanceCardList.css';

const SYSTEM_ACCOUNT = '000000000000000000000000';

const FinanceCategoryCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const isSystem = row.account === SYSTEM_ACCOUNT;

  return (
    <div className={`finance-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="finance-card-main">
        <div className="finance-card-category">{row.name ? t(row.name, { defaultValue: row.name }) : '—'}</div>
        <div className="finance-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="finance-card-secondary">
          {isSystem ? t('breed_type_system') : t('breed_type_custom')}
        </div>
      </div>

      {expanded && (
        <div className="finance-card-detail" onClick={e => e.stopPropagation()}>
          <div className="finance-card-detail-row">
            <span>{t('aliases')}</span>
            <span>{row.matches || '—'}</span>
          </div>
          <div className="finance-card-detail-row">
            <span>{t('type')}</span>
            <span>{isSystem ? t('breed_type_system') : t('breed_type_custom')}</span>
          </div>
          {!isSystem && (
            <div className="finance-card-actions">
              <DeleteButton
                collection="finance.categories"
                data={[row]}
                onComplete={onDeleted}
                onError={() => {}}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const FinanceCategoryCardList = ({ data, onRefresh }) => (
  <div className="finance-card-list">
    {data && data.map(row => (
      <FinanceCategoryCard key={row._id} row={row} onDeleted={onRefresh} />
    ))}
    {(!data || data.length === 0) && (
      <div className="finance-card-empty">—</div>
    )}
  </div>
);

export const ListFinanceCategories = () => {
  const { t } = useTranslation();

  const columns = [
    { name: t('category'),  selector: row => t(row.name, { defaultValue: row.name }),    sortable: true },
    { name: t('aliases'),   selector: row => row.matches },
    {
      name: t('type'),
      selector: row => row.account === SYSTEM_ACCOUNT ? t('breed_type_system') : t('breed_type_custom'),
      sortable: true,
    },
  ];

  return (
    <DataCollection
      collection="finance.categories"
      columns={columns}
      sortField={3}
      mobileComponent={(data, onRefresh) => (
        <FinanceCategoryCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
};

export default ListFinanceCategories;
